// src/pages/LoginPage.jsx
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  // // async function handleSubmit(e) {
  // //   e.preventDefault();
  // //   setError("");
  // //   setLoading(true);
  // //   try {
  // //     await login(email, password);
  // //     navigate("/dashboard");
  // //   } catch (err) {
  // //     const msg = err.code === "auth/invalid-credential"
  // //       ? "Invalid email or password. Please try again."
  // //       : "Failed to sign in. Please try again.";
  // //     setError(msg);
  // //   }
  // //   setLoading(false);
  // // }

  async function handleSubmit(e) {
  e.preventDefault();
  setError("");
  setLoading(true);
  try {
    const cred = await login(email, password);
    // Check if email is verified
    if (!cred.user.emailVerified) {
      navigate("/verify-email");
    } else {
      navigate("/dashboard");
    }
  } catch (err) {
    const msg = err.code === "auth/invalid-credential"
      ? "Invalid email or password. Please try again."
      : "Failed to sign in. Please try again.";
    setError(msg);
  }
  setLoading(false);
}

  return (
    <div style={{ minHeight: "100vh", background: "var(--gray-50)", display: "flex", flexDirection: "column" }}>
      {/* NAV */}
      <nav style={{ borderBottom: "1px solid var(--gray-200)", padding: "0 32px", height: 60, display: "flex", alignItems: "center", background: "#fff" }}>
        <Link to="/" style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ width: 30, height: 30, background: "var(--blue)", borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ color: "#fff", fontSize: 14 }}>📄</span>
          </div>
          <span style={{ fontWeight: 700, fontSize: 16 }}>ResumeScore<span style={{ color: "var(--blue)" }}>AI</span></span>
        </Link>
      </nav>

      {/* FORM */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "32px 16px" }}>
        <div style={{ width: "100%", maxWidth: 400 }}>
          <div className="card" style={{ padding: "36px 32px" }}>
            <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 6, letterSpacing: "-0.02em" }}>Welcome back</h1>
            <p style={{ fontSize: 14, color: "var(--gray-500)", marginBottom: 28 }}>Sign in to your ResumeScoreAI account</p>

            {error && (
              <div style={{ background: "var(--red-light)", color: "var(--red)", fontSize: 13, padding: "10px 14px", borderRadius: 8, marginBottom: 20, border: "1px solid #f0a0a0" }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email address</label>
                <input className="form-input" type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} required />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input className="form-input" type="password" placeholder="Enter your password" value={password} onChange={e => setPassword(e.target.value)} required />
                    <Link
      to="/forgot-password"
      style={{ fontSize: 13, color: "var(--blue)", fontWeight: 500 }}
    >
      Forgot password?
    </Link>
              </div>
              <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={loading} style={{ marginTop: 8 }}>
                {loading ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Signing in...</> : "Sign In"}
              </button>
            </form>
          </div>

          <p style={{ textAlign: "center", marginTop: 20, fontSize: 14, color: "var(--gray-600)" }}>
            Don't have an account?{" "}
            <Link to="/signup" style={{ color: "var(--blue)", fontWeight: 500 }}>Sign up free</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
